import moment from "moment";
import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import RowDetailsCellDetails from "./RowDetailsCellDetails";
import RowDetailsCellHeader from "./RowDetailsCellHeader";

class RowDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moduleCalibration: props.moduleCalibration,
      tooltipOpen: false,
    };
  }

  render() {
    const { moduleCalibration } = this.state;

    return (
      <Row>
        {/************************** DOWNSTREAM PARAMS **************************/}

        <Row className="col-sm-12 mb-5">
          <Col sm="3">
            <RowDetailsCellHeader
              title="DS PRE Ch1"
              icon="pe-7s-note"
              iconBg="info"
              body1={
                moduleCalibration["dsPRECh1"] !== undefined &&
                moduleCalibration["dsPRECh1"] != null
                  ? Number(moduleCalibration.dsPRECh1.toFixed(10))
                  : "-"
              }
            />
          </Col>
          <Col sm="3">
            <RowDetailsCellHeader
              title="DS PRE Ch2"
              icon="pe-7s-note"
              iconBg="info"
              body1={
                moduleCalibration["dsPRECh2"] !== undefined &&
                moduleCalibration["dsPRECh2"] != null
                  ? Number(moduleCalibration.dsPRECh2.toFixed(10))
                  : "-"
              }
            />
          </Col>
          <Col sm="3">
            <RowDetailsCellHeader
              title="DS PRE Ch3"
              icon="pe-7s-note"
              iconBg="info"
              body1={
                moduleCalibration["dsPRECh3"] !== undefined &&
                moduleCalibration["dsPRECh3"] != null
                  ? Number(moduleCalibration.dsPRECh3.toFixed(10))
                  : "-"
              }
            />
          </Col>
          <Col sm="3">
            <RowDetailsCellHeader
              title="DS PRE Ch4"
              icon="pe-7s-note"
              iconBg="info"
              body1={
                moduleCalibration["dsPRECh4"] !== undefined &&
                moduleCalibration["dsPRECh4"] != null
                  ? Number(moduleCalibration.dsPRECh4.toFixed(10))
                  : "-"
              }
            />
          </Col>
        </Row>

        {/************************** DATES **************************/}
        <Row className="col-sm-12 mb-5 mt-3">
          <Col>
            <RowDetailsCellHeader
              title="Start"
              icon="lnr-clock"
              iconBg="info"
              body1={
                moduleCalibration["startDate"] !== undefined &&
                moduleCalibration["startDate"] != null
                  ? moment(moduleCalibration.startDate, "x").format(
                      "DD/MM/YYYY"
                    )
                  : "-"
              }
              body2={
                moduleCalibration["startDate"] !== undefined &&
                moduleCalibration["startDate"] != null
                  ? moment(moduleCalibration.startDate, "x").format("HH:mm:ss")
                  : "-"
              }
            />
          </Col>

          <Col>
            <RowDetailsCellHeader
              title="Last Update"
              icon="lnr-clock"
              iconBg="warning"
              body1={
                moduleCalibration["updateDate"] !== undefined &&
                moduleCalibration["updateDate"] != null
                  ? moment(moduleCalibration.updateDate, "x").format(
                      "DD/MM/YYYY"
                    )
                  : "-"
              }
              body2={
                moduleCalibration["updateDate"] !== undefined &&
                moduleCalibration["updateDate"] != null
                  ? moment(moduleCalibration.updateDate, "x").format("HH:mm:ss")
                  : "-"
              }
            />
          </Col>

          <Col>
            <RowDetailsCellHeader
              title="End"
              icon="lnr-clock"
              iconBg="success"
              body1={
                moduleCalibration["endDate"] !== undefined &&
                moduleCalibration["endDate"] != null
                  ? moment(moduleCalibration.endDate, "x").format("DD/MM/YYYY")
                  : "-"
              }
              body2={
                moduleCalibration["endDate"] !== undefined &&
                moduleCalibration["endDate"] != null
                  ? moment(moduleCalibration.endDate, "x").format("HH:mm:ss")
                  : "-"
              }
            />
          </Col>
        </Row>

        {/************************** CALBOARD ID / CRONJOB **************************/}
        <Row className="col-sm-12 mb-5">
          <Col>
            <RowDetailsCellHeader
              title="Calibration Board"
              icon="pe-7s-safe"
              iconBg="secondary"
              body1={
                moduleCalibration["calibrationBoardId"]
                  ? moduleCalibration["calibrationBoardId"]
                  : "-"
              }
            />
          </Col>

          <Col>
            <RowDetailsCellHeader
              title="Cron Job"
              icon="pe-7s-clock"
              iconBg="secondary"
              body1={
                moduleCalibration["endedByCron"] ? (
                  <i className="lnr-warning"> YES</i>
                ) : (
                  "-"
                )
              }
            />
          </Col>
        </Row>

        {/************************** COMMENT **************************/}
        <Row className="col-sm-12 mb-5">
          <Col>
            <RowDetailsCellHeader
              title="Comment"
              icon="pe-7s-comment"
              iconBg="danger"
              body1={
                moduleCalibration["usComment"] != null
                  ? moduleCalibration.usComment
                  : "-"
              }
            />
          </Col>
        </Row>

        {/************************** MODULE CALIBRATION DETAILS **************************/}
        <Row className="col-sm-12 mb-5">
          <Col sm="12">
            <Row className="mb-2">
              <div
                className="icon-wrapper rounded-circle"
                style={{
                  height: "30px",
                  width: "30px",
                  margin: "0px 0px 0px 20px",
                }}
              >
                <div className="icon-wrapper-bg opacity-7 bg-light" />
                <i
                  className="pe-7s-news-paper"
                  style={{ color: "black", fontSize: "16px" }}
                />
              </div>
              <div className="widget-chart-content text-left ml-3">
                <div className="widget-subheading" style={{ marginTop: "4px" }}>
                  <b style={{ color: "black" }}>Details</b>
                </div>
              </div>
            </Row>

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="Error Debug"
              body1={
                moduleCalibration["errorDebug"]
                  ? moduleCalibration["errorDebug"]
                  : "-"
              }
              title2="Part Number"
              body2={moduleCalibration["pn"] ? moduleCalibration["pn"] : "-"}
              title3="TuningTimesTX1_2"
              body3={
                moduleCalibration["tuningTimesTx1_2"] != null // check nullity due to number zero
                  ? moduleCalibration["tuningTimesTx1_2"]
                  : "-"
              }
              title4="TuningTimesTX2_3"
              body4={
                moduleCalibration["tuningTimesTx2_3"] != null
                  ? moduleCalibration["tuningTimesTx2_3"]
                  : "-"
              }
              title5="TuningTimesTX3_4"
              body5={
                moduleCalibration["tuningTimesTx3_4"] != null
                  ? moduleCalibration["tuningTimesTx3_4"]
                  : "-"
              }
              title6="TuningTimesTX4_3"
              body6={
                moduleCalibration["tuningTimesTx4_3"] != null
                  ? moduleCalibration["tuningTimesTx4_3"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="TuningTimesTX3_2"
              body1={
                moduleCalibration["tuningTimesTx3_2"] != null
                  ? moduleCalibration["tuningTimesTx3_2"]
                  : "-"
              }
              title2="TuningTimesTX2_4"
              body2={
                moduleCalibration["tuningTimesTx2_4"] != null
                  ? moduleCalibration["tuningTimesTx2_4"]
                  : "-"
              }
              title3="TuningTimesTX4_2"
              body3={
                moduleCalibration["tuningTimesTx4_2"] != null
                  ? moduleCalibration["tuningTimesTx4_2"]
                  : "-"
              }
              title4="TuningTimesTX2_1"
              body4={
                moduleCalibration["tuningTimesTx2_1"] != null
                  ? moduleCalibration["tuningTimesTx2_1"]
                  : "-"
              }
              title5="TuningTimesTX1_4"
              body5={
                moduleCalibration["tuningTimesTx1_4"] != null
                  ? moduleCalibration["tuningTimesTx1_4"]
                  : "-"
              }
              title6="TuningTimesTX4_1"
              body6={
                moduleCalibration["tuningTimesTx4_1"] != null
                  ? moduleCalibration["tuningTimesTx4_1"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="TuningTimesTX1_3"
              body1={
                moduleCalibration["tuningTimesTx1_3"] != null
                  ? moduleCalibration["tuningTimesTx1_3"]
                  : "-"
              }
              title2="TuningTimesTX3_1"
              body2={
                moduleCalibration["tuningTimesTx3_1"] != null
                  ? moduleCalibration["tuningTimesTx3_1"]
                  : "-"
              }
              title3="TuningTimesRX1_2"
              body3={
                moduleCalibration["tuningTimesRx1_2"] != null
                  ? moduleCalibration["tuningTimesRx1_2"]
                  : "-"
              }
              title4="TuningTimesRX2_3"
              body4={
                moduleCalibration["tuningTimesRx2_3"] != null
                  ? moduleCalibration["tuningTimesRx2_3"]
                  : "-"
              }
              title5="TuningTimesRX3_4"
              body5={
                moduleCalibration["tuningTimesRx3_4"] != null
                  ? moduleCalibration["tuningTimesRx3_4"]
                  : "-"
              }
              title6="TuningTimesRX4_3"
              body6={
                moduleCalibration["tuningTimesRx4_3"] != null
                  ? moduleCalibration["tuningTimesRx4_3"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="TuningTimesRX3_2"
              body1={
                moduleCalibration["tuningTimesRx3_2"] != null
                  ? moduleCalibration["tuningTimesRx3_2"]
                  : "-"
              }
              title2="TuningTimesRX2_4"
              body2={
                moduleCalibration["tuningTimesRx2_4"] != null
                  ? moduleCalibration["tuningTimesRx2_4"]
                  : "-"
              }
              title3="TuningTimesRX4_2"
              body3={
                moduleCalibration["tuningTimesRx4_2"] != null
                  ? moduleCalibration["tuningTimesRx4_2"]
                  : "-"
              }
              title4="TuningTimesRX2_1"
              body4={
                moduleCalibration["tuningTimesRx2_1"] != null
                  ? moduleCalibration["tuningTimesRx2_1"]
                  : "-"
              }
              title5="TuningTimesRX1_4"
              body5={
                moduleCalibration["tuningTimesRx1_4"] != null
                  ? moduleCalibration["tuningTimesRx1_4"]
                  : "-"
              }
              title6="TuningTimesRX4_1"
              body6={
                moduleCalibration["tuningTimesRx4_1"] != null
                  ? moduleCalibration["tuningTimesRx4_1"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="TuningTimesRX1_3"
              body1={
                moduleCalibration["tuningTimesRx1_3"] != null
                  ? moduleCalibration["tuningTimesRx1_3"]
                  : "-"
              }
              title2="TuningTimesRX3_1"
              body2={
                moduleCalibration["tuningTimesRx3_1"] != null
                  ? moduleCalibration["tuningTimesRx3_1"]
                  : "-"
              }
              title3="Password EEPROM Entry 1"
              body3={
                moduleCalibration["passwordEEPROMEntry1"] != null
                  ? moduleCalibration["passwordEEPROMEntry1"]
                  : "-"
              }
              title4="Password EEPROM Entry 2"
              body4={
                moduleCalibration["passwordEEPROMEntry2"] != null
                  ? moduleCalibration["passwordEEPROMEntry2"]
                  : "-"
              }
              title5="Password EEPROM Entry 3"
              body5={
                moduleCalibration["passwordEEPROMEntry3"] != null
                  ? moduleCalibration["passwordEEPROMEntry3"]
                  : "-"
              }
              title6="Password EEPROM Entry 4"
              body6={
                moduleCalibration["passwordEEPROMEntry4"] != null
                  ? moduleCalibration["passwordEEPROMEntry4"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="Password Vendor Entry 1"
              body1={
                moduleCalibration["passwordVendorEntry1"] != null
                  ? moduleCalibration["passwordVendorEntry1"]
                  : "-"
              }
              title2="Password Vendor Entry 2"
              body2={
                moduleCalibration["passwordVendorEntry2"] != null
                  ? moduleCalibration["passwordVendorEntry2"]
                  : "-"
              }
              title3="Password Vendor Entry 3"
              body3={
                moduleCalibration["passwordVendorEntry3"] != null
                  ? moduleCalibration["passwordVendorEntry3"]
                  : "-"
              }
              title4="Password Vendor Entry 4"
              body4={
                moduleCalibration["passwordVendorEntry4"] != null
                  ? moduleCalibration["passwordVendorEntry4"]
                  : "-"
              }
              title5="Temperature TX"
              body5={
                moduleCalibration["temperatureTx"] != null
                  ? moduleCalibration["temperatureTx"]
                  : "-"
              }
              title6="Temperature RX"
              body6={
                moduleCalibration["temperatureRx"] != null
                  ? moduleCalibration["temperatureRx"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="TECTX CH1"
              body1={
                moduleCalibration["tecTxCH1"] != null
                  ? moduleCalibration["tecTxCH1"]
                  : "-"
              }
              title2="TECTX CH2"
              body2={
                moduleCalibration["tecTxCH2"] != null
                  ? moduleCalibration["tecTxCH2"]
                  : "-"
              }
              title3="TECTX CH3"
              body3={
                moduleCalibration["tecTxCH3"] != null
                  ? moduleCalibration["tecTxCH3"]
                  : "-"
              }
              title4="TECTX CH4"
              body4={
                moduleCalibration["tecTxCH4"] != null
                  ? moduleCalibration["tecTxCH4"]
                  : "-"
              }
              title5="BurstAcc TX CH1"
              body5={
                moduleCalibration["burstAccTxCH1"] != null
                  ? moduleCalibration["burstAccTxCH1"]
                  : "-"
              }
              title6="BurstAcc TX CH2"
              body6={
                moduleCalibration["burstAccTxCH2"] != null
                  ? moduleCalibration["burstAccTxCH2"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="BurstAcc TX CH3"
              body1={
                moduleCalibration["burstAccTxCH3"] != null
                  ? moduleCalibration["burstAccTxCH3"]
                  : "-"
              }
              title2="BurstAcc TX CH4"
              body2={
                moduleCalibration["burstAccTxCH4"] != null
                  ? moduleCalibration["burstAccTxCH4"]
                  : "-"
              }
              title3="IdleAcc TX CH1"
              body3={
                moduleCalibration["idleAccTxCH1"] != null
                  ? moduleCalibration["idleAccTxCH1"]
                  : "-"
              }
              title4="IdleAcc TX CH2"
              body4={
                moduleCalibration["idleAccTxCH2"] != null
                  ? moduleCalibration["idleAccTxCH2"]
                  : "-"
              }
              title5="IdleAcc TX CH3"
              body5={
                moduleCalibration["idleAccTxCH3"] != null
                  ? moduleCalibration["idleAccTxCH3"]
                  : "-"
              }
              title6="IdleAcc TX CH4"
              body6={
                moduleCalibration["idleAccTxCH4"] != null
                  ? moduleCalibration["idleAccTxCH4"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="IBias CH1"
              body1={
                moduleCalibration["iBiasCH1"] != null
                  ? moduleCalibration["iBiasCH1"]
                  : "-"
              }
              title2="IBias CH2"
              body2={
                moduleCalibration["iBiasCH2"] != null
                  ? moduleCalibration["iBiasCH2"]
                  : "-"
              }
              title3="IBias CH3"
              body3={
                moduleCalibration["iBiasCH3"] != null
                  ? moduleCalibration["iBiasCH3"]
                  : "-"
              }
              title4="IBias CH4"
              body4={
                moduleCalibration["iBiasCH4"] != null
                  ? moduleCalibration["iBiasCH4"]
                  : "-"
              }
              title5="IMod CH1"
              body5={
                moduleCalibration["iModCH1"] != null
                  ? moduleCalibration["iModCH1"]
                  : "-"
              }
              title6="IMod CH2"
              body6={
                moduleCalibration["iModCH2"] != null
                  ? moduleCalibration["iModCH2"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="IMod CH3"
              body1={
                moduleCalibration["iModCH3"] != null
                  ? moduleCalibration["iModCH3"]
                  : "-"
              }
              title2="IMod CH4"
              body2={
                moduleCalibration["iModCH4"] != null
                  ? moduleCalibration["iModCH4"]
                  : "-"
              }
              title3="TEC RX CH1"
              body3={
                moduleCalibration["tecRxCH1"] != null
                  ? moduleCalibration["tecRxCH1"]
                  : "-"
              }
              title4="TEC RX CH2"
              body4={
                moduleCalibration["tecRxCH2"] != null
                  ? moduleCalibration["tecRxCH2"]
                  : "-"
              }
              title5="TEC RX CH3"
              body5={
                moduleCalibration["tecRxCH3"] != null
                  ? moduleCalibration["tecRxCH3"]
                  : "-"
              }
              title6="TEC RX CH4"
              body6={
                moduleCalibration["tecRxCH4"] != null
                  ? moduleCalibration["tecRxCH4"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="Acc RX CH3 Low"
              body1={
                moduleCalibration["accRxCH3Low"] != null
                  ? moduleCalibration["accRxCH3Low"]
                  : "-"
              }
              title2="Acc RX CH4 Low"
              body2={
                moduleCalibration["accRxCH4Low"] != null
                  ? moduleCalibration["accRxCH4Low"]
                  : "-"
              }
              title3="Acc RX CH1"
              body3={
                moduleCalibration["accRxCH1"] != null
                  ? moduleCalibration["accRxCH1"]
                  : "-"
              }
              title4="Acc RX CH2"
              body4={
                moduleCalibration["accRxCH2"] != null
                  ? moduleCalibration["accRxCH2"]
                  : "-"
              }
              title5="Acc RX CH3"
              body5={
                moduleCalibration["accRxCH3"] != null
                  ? moduleCalibration["accRxCH3"]
                  : "-"
              }
              title6="Acc RX CH4"
              body6={
                moduleCalibration["accRxCH4"] != null
                  ? moduleCalibration["accRxCH4"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="Acc RX CH1 Upp"
              body1={
                moduleCalibration["accRXCH1Upp"] != null
                  ? moduleCalibration["accRXCH1Upp"]
                  : "-"
              }
              title2="VAPD"
              body2={
                moduleCalibration["vapd"] ? moduleCalibration["vapd"] : "-"
              }
              title3="TX Power High_Slope"
              body3={
                moduleCalibration["txPowerHigh_Slope"] != null
                  ? moduleCalibration["txPowerHigh_Slope"]
                  : "-"
              }
              title4="TX Power High OffSetMSB"
              body4={
                moduleCalibration["txPowerHigh_OffSetMSB"] != null
                  ? moduleCalibration["txPowerHigh_OffSetMSB"]
                  : "-"
              }
              title5="TX Power High OffSetLSB"
              body5={
                moduleCalibration["txPowerHigh_OffSetLSB"] != null
                  ? moduleCalibration["txPowerHigh_OffSetLSB"]
                  : "-"
              }
              title6="TX Power Low Slope"
              body6={
                moduleCalibration["txPowerLow_Slope"] != null
                  ? moduleCalibration["txPowerLow_Slope"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="TX Power Low OffSetMSB"
              body1={
                moduleCalibration["txPowerLow_OffSetMSB"] != null
                  ? moduleCalibration["txPowerLow_OffSetMSB"]
                  : "-"
              }
              title2="TX Power Low OffSetLSB"
              body2={
                moduleCalibration["txPowerLow_OffSetLSB"] != null
                  ? moduleCalibration["txPowerLow_OffSetLSB"]
                  : "-"
              }
              title3="Resistence AccIdle TX"
              body3={
                moduleCalibration["resistenceAccIdleTx"] != null
                  ? moduleCalibration["resistenceAccIdleTx"]
                  : "-"
              }
              title4="Resistence Acc RX"
              body4={
                moduleCalibration["resistenceAccRX"] != null
                  ? moduleCalibration["resistenceAccRX"]
                  : "-"
              }
              title5="Time Over Shoot 1"
              body5={
                moduleCalibration["timeOverShoot1"] != null
                  ? moduleCalibration["timeOverShoot1"]
                  : "-"
              }
              title6="Time Over Shoot 2"
              body6={
                moduleCalibration["timeOverShoot2"] != null
                  ? moduleCalibration["timeOverShoot2"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="Time Over Shoot 3"
              body1={
                moduleCalibration["timeOverShoot3"] != null
                  ? moduleCalibration["timeOverShoot3"]
                  : "-"
              }
              title2="Time Over Shoot 4"
              body2={
                moduleCalibration["timeOverShoot4"] != null
                  ? moduleCalibration["timeOverShoot4"]
                  : "-"
              }
              title3="Shift TEC TX"
              body3={
                moduleCalibration["shiftTecTx"] != null
                  ? moduleCalibration["shiftTecTx"]
                  : "-"
              }
              title4="Shift Acc TX"
              body4={
                moduleCalibration["shiftAccTx"] != null
                  ? moduleCalibration["shiftAccTx"]
                  : "-"
              }
              title5="Shift TEC RX CH3 LOW"
              body5={
                moduleCalibration["shiftTecRxCH3LOW"] != null
                  ? moduleCalibration["shiftTecRxCH3LOW"]
                  : "-"
              }
              title6="Shift TEC RX CH4 LOW"
              body6={
                moduleCalibration["shiftTecRxCH4LOW"] != null
                  ? moduleCalibration["shiftTecRxCH4LOW"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="Shift TEC RX CH1"
              body1={
                moduleCalibration["shiftTecRxCH1"] != null
                  ? moduleCalibration["shiftTecRxCH1"]
                  : "-"
              }
              title2="Shift TEC RX CH2"
              body2={
                moduleCalibration["shiftTecRxCH2"] != null
                  ? moduleCalibration["shiftTecRxCH2"]
                  : "-"
              }
              title3="Shift TEC RX CH3"
              body3={
                moduleCalibration["shiftTecRxCH3"] != null
                  ? moduleCalibration["shiftTecRxCH3"]
                  : "-"
              }
              title4="Shift TEC RX CH4"
              body4={
                moduleCalibration["shiftTecRxCH4"] != null
                  ? moduleCalibration["shiftTecRxCH4"]
                  : "-"
              }
              title5="Shift TEC RX CH1 UP"
              body5={
                moduleCalibration["shiftTecRxCH1UP"] != null
                  ? moduleCalibration["shiftTecRxCH1UP"]
                  : "-"
              }
              title6="DDMIRX 28"
              body6={
                moduleCalibration["ddmirx28"] != null
                  ? moduleCalibration["ddmirx28"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="DDMIRX 23"
              body1={
                moduleCalibration["ddmirx23"] != null
                  ? moduleCalibration["ddmirx23"]
                  : "-"
              }
              title2="DDMIRX 18"
              body2={
                moduleCalibration["ddmirx18"] != null
                  ? moduleCalibration["ddmirx18"]
                  : "-"
              }
              title3="DDMIRX 13"
              body3={
                moduleCalibration["ddmirx13"] != null
                  ? moduleCalibration["ddmirx13"]
                  : "-"
              }
              title4="DDMIRX 8"
              body4={
                moduleCalibration["ddmirx8"] != null
                  ? moduleCalibration["ddmirx8"]
                  : "-"
              }
              title5="TEC Lim TX"
              body5={
                moduleCalibration["tecLimTX"] != null
                  ? moduleCalibration["tecLimTX"]
                  : "-"
              }
              title6="TEC Lim RX"
              body6={
                moduleCalibration["tecLimRX"] != null
                  ? moduleCalibration["tecLimRX"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="Limit RXControl RSSI"
              body1={
                moduleCalibration["limitRXControlRSSI"] != null
                  ? moduleCalibration["limitRXControlRSSI"]
                  : "-"
              }
              title2="RSSI Residual Min"
              body2={
                moduleCalibration["rssiResidualMin"] != null
                  ? moduleCalibration["rssiResidualMin"]
                  : "-"
              }
              title3="RSSI Residual Max"
              body3={
                moduleCalibration["rssiResidualMax"] != null
                  ? moduleCalibration["rssiResidualMax"]
                  : "-"
              }
              title4="Apd Shift"
              body4={
                moduleCalibration["apdShift"] != null
                  ? moduleCalibration["apdShift"]
                  : "-"
              }
              title5="Module Status"
              body5={
                moduleCalibration["moduleStatus"] != null
                  ? moduleCalibration["moduleStatus"]
                  : "-"
              }
              title6="Checksum"
              body6={
                moduleCalibration["checkSum"] != null
                  ? moduleCalibration["checkSum"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="Power TX Ch1"
              body1={
                moduleCalibration["powerTxCh1"] != null
                  ? moduleCalibration["powerTxCh1"]
                  : "-"
              }
              title2="Power TX Ch2"
              body2={
                moduleCalibration["powerTxCh2"] != null
                  ? moduleCalibration["powerTxCh2"]
                  : "-"
              }
              title3="Power TX Ch3"
              body3={
                moduleCalibration["powerTxCh3"] != null
                  ? moduleCalibration["powerTxCh3"]
                  : "-"
              }
              title4="Power TX Ch4"
              body4={
                moduleCalibration["powerTxCh4"] != null
                  ? moduleCalibration["powerTxCh4"]
                  : "-"
              }
              title5="BER Rx Isolation High"
              body5={
                moduleCalibration["berRxIsolationHigh"] != null
                  ? moduleCalibration["berRxIsolationHigh"]
                  : "-"
              }
              title6="BER Rx Isolation Low"
              body6={
                moduleCalibration["berRxIsolationLow"] != null
                  ? moduleCalibration["berRxIsolationLow"]
                  : "-"
              }
            />

            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="DDMI TX POWER"
              body1={
                moduleCalibration["ddmiTxPower"] != null
                  ? moduleCalibration["ddmiTxPower"]
                  : "-"
              }
              title2="DDMI RX POWER"
              body2={
                moduleCalibration["ddmiRxPower"] != null
                  ? moduleCalibration["ddmiRxPower"]
                  : "-"
              }
              title3="VDD"
              body3={
                moduleCalibration["vdd"] != null
                  ? moduleCalibration["vdd"]
                  : "-"
              }
              title4="TX Bias"
              body4={
                moduleCalibration["txBias"] != null
                  ? moduleCalibration["txBias"]
                  : "-"
              }
              title5="Status 1"
              body5={
                moduleCalibration["status1"] != null
                  ? moduleCalibration["status1"]
                  : "-"
              }
              title6="Status 2"
              body6={
                moduleCalibration["status2"] != null
                  ? moduleCalibration["status2"]
                  : "-"
              }
            />


            <RowDetailsCellDetails
              className="col-sm-12 mb-2"
              title1="FPGA 0 Temperature Local"
              body1={
                moduleCalibration["fpga0temperatureLocal"] != null
                  ? moduleCalibration["fpga0temperatureLocal"]
                  : "-"
              }
              title2="FPGA 0 Temperature Remote"
              body2={
                moduleCalibration["fpga0temperatureRemote"] != null
                  ? moduleCalibration["fpga0temperatureRemote"]
                  : "-"
              }
              title3="FPGA 1 Temperature Local"
              body3={
                moduleCalibration["fpga1temperatureLocal"] != null
                  ? moduleCalibration["fpga1temperatureLocal"]
                  : "-"
              }
              title4="FPGA 1 Temperature Remote"
              body4={
                moduleCalibration["fpga1temperatureRemote"] != null
                  ? moduleCalibration["fpga1temperatureRemote"]
                  : "-"
              }
              title5="Slot XFP"
              body5={
                moduleCalibration["slotXFP"] != null
                  ? moduleCalibration["slotXFP"]
                  : "-"
              }
              title6="ID Module"
              body6={
                moduleCalibration["idModule"] != null
                  ? moduleCalibration["idModule"]
                  : "-"
              }
            />
          </Col>
        </Row>
      </Row>
    );
  }
}

export default RowDetails;



// WEBPACK FOOTER //
// ./src/Clients/PicaC&SVz/components/RowDetails.js